import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[appUsernameValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: UsernameValidatorDirective,
    multi: true
  }],
  standalone: true
})
export class UsernameValidatorDirective implements Validator {
  /**
   * Validates the username based on specific rules:
   * 1. Must be between 3 and 60 characters.
   * 2. Must contain only alphanumeric characters and underscores.
   * 3. Must contain at least one alphabetic character.
   * @param control The form control to validate
   * @returns ValidationErrors if invalid, null if valid
   */
  validate(control: AbstractControl): ValidationErrors | null {
    const username = control.value;
    
    // If the field is empty, let 'required' validator handle it if present
    if (!username) {
      return null;
    }

    const errors: ValidationErrors = {};

    // Rule 1: Length check
    if (username.length < 3 || username.length > 60) {
      errors['usernameLength'] = {
        actual: username.length,
        required: '3-60 characters'
      };
    }

    // Rule 2: Pattern check (alphanumeric and underscores only)
    const patternRegex = /^[a-zA-Z0-9_]*$/;
    if (!patternRegex.test(username)) {
      errors['usernamePattern'] = true;
    }

    // Rule 3: Must contain at least one alphabetic character
    const alphaRegex = /[a-zA-Z]/;
    if (!alphaRegex.test(username)) {
      errors['noAlphaChar'] = true;
    }

    return Object.keys(errors).length > 0 ? errors : null;
  }
}
